export default {
  methods: {
    showDangerAlert({
      title = 'Σφάλμα!',
      message = 'Άγνωστο σφάλμα. Προσπαθήστε ξανά αργότερα.',
      noAutoHide = false,
      autoHideDelay = 5000,
      appendToast = false,
    }) {
      this.$bvToast.toast(message, {
        title,
        message,
        noAutoHide,
        autoHideDelay,
        appendToast,
        variant: 'danger',
      });
    },
    showSuccessAlert({
      title = 'Επιτυχία!',
      message = 'Οι αλλαγές αποθηκεύτηκαν επιτυχώς',
      noAutoHide = false,
      autoHideDelay = 5000,
      appendToast = false,
    }) {
      this.$bvToast.toast(message, {
        title,
        message,
        noAutoHide,
        autoHideDelay,
        appendToast,
        variant: 'success',
      });
    },
    showWarningAlert({
      title = 'Προσοχή!',
      message = '',
      noAutoHide = false,
      autoHideDelay = 5000,
      appendToast = false,
    }) {
      this.$bvToast.toast(message, {
        title,
        message,
        noAutoHide,
        autoHideDelay,
        appendToast,
        variant: 'warning',
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/mixins/toast.js